import styled from 'styled-components';
import { Button } from '@karma/components';

export const StyledButton = styled(Button)`
  margin-right: 16px;
`;
